import React from 'react'
import {Lang} from 'yougile-lang'
import {logger} from 'yougile-util'
import {ClientUtilities} from '@client/client-utilities'
import {FileChooser} from '@common/file-chooser'
import {Button} from '@components/common/base/buttons'
import {MessageBox} from '@components/message-box'

export const ExtensionCustomUploadButton = () => {
  const handleFileChoose = async (event: React.MouseEvent<HTMLElement>) => {
    try {
      const file = await FileChooser.chooseFile(event, false, undefined, '.zip')

      const fileType = (file.type || '').toLowerCase()

      if (!fileType.includes('zip')) {
        MessageBox.warn(Lang.msg.extensions.supportOnlyZip)
        return
      }

      void ClientUtilities.saveExtension({file})
    } catch (e) {
      MessageBox.danger(Lang.msg.extensions.errorOnInstall)
      logger.error(e)
      return
    }
  }

  return (
    <Button size="small" onClick={handleFileChoose}>
      {Lang.msg.extensions.installCustom}
    </Button>
  )
}
